import { API } from './constant';
import { HttpRequest } from '../../lib/http';
import { FORM_VALUE_INTER } from '../user-item-create/constant';

export const updateUser = (id: string, payload: FORM_VALUE_INTER) => {
  return HttpRequest({
    method: API.UPDATE.TYPE,
    url: API.UPDATE.URL(id),
    data: payload,
  });
};
